import { useFirestoreQueryData } from "@react-query-firebase/firestore";
import { ideasRef } from "../data/collections";

export const useGetAllIdeas = () => {
  return useFirestoreQueryData(["ideas"], ideasRef, {
    subscribe: true,
    idField: "_id",
  });
};
